import { MarketingLayout } from "./MarketingLayout";
import HomePage from "../pages/marketing/HomePage";
import ValeursPage from "../pages/marketing/ValeursPage";
import PricingPage from "../pages/marketing/PricingPage";
import ContactPage from "../pages/marketing/ContactPage";
import LegalPage from "../pages/marketing/LegalPage";
import PrivacyPage from "../pages/marketing/PrivacyPage";
import FonctionnalitesPage from "../pages/marketing/FonctionnalitesPage";
import ComparatifPage from "../pages/marketing/ComparatifPage";
import VsDustPage from "../pages/marketing/VsDustPage";
import VsChatgptEnterprisePage from "../pages/marketing/VsChatgptEnterprisePage";
import BlogPage from "../pages/marketing/BlogPage";
import BlogPostPage from "../pages/marketing/BlogPostPage";
import OcrPage from "../pages/marketing/fonctionnalites/OcrPage";
import SecuritePage from "../pages/marketing/fonctionnalites/SecuritePage";
import WhiteLabelPage from "../pages/marketing/fonctionnalites/WhiteLabelPage";
import {
  SecteurRHPage,
  SecteurRecrutementPage,
  SecteurAvocatsPage,
  SecteurImmobilierPage,
  SecteurNotairesPage,
  SecteurComptablesPage,
} from "../pages/marketing/secteurs/SecteursPages";

export const marketingRoutes = [
  {
    element: <MarketingLayout />,
    children: [
      { path: "/", element: <HomePage /> },
      { path: "/valeurs", element: <ValeursPage /> },
      { path: "/fonctionnalites", element: <FonctionnalitesPage /> },
      { path: "/fonctionnalites/ocr", element: <OcrPage /> },
      { path: "/fonctionnalites/securite", element: <SecuritePage /> },
      { path: "/fonctionnalites/white-label", element: <WhiteLabelPage /> },
      { path: "/comparatif", element: <ComparatifPage /> },
      { path: "/vs/dust", element: <VsDustPage /> },
      { path: "/vs/chatgpt-enterprise", element: <VsChatgptEnterprisePage /> },
      { path: "/blog", element: <BlogPage /> },
      { path: "/blog/:slug", element: <BlogPostPage /> },
      { path: "/tarifs", element: <PricingPage /> },
      { path: "/contact", element: <ContactPage /> },
      { path: "/mentions-legales", element: <LegalPage /> },
      { path: "/confidentialite", element: <PrivacyPage /> },
      { path: "/secteurs/rh", element: <SecteurRHPage /> },
      { path: "/secteurs/recrutement", element: <SecteurRecrutementPage /> },
      { path: "/secteurs/avocats", element: <SecteurAvocatsPage /> },
      { path: "/secteurs/immobilier", element: <SecteurImmobilierPage /> },
      { path: "/secteurs/notaires", element: <SecteurNotairesPage /> },
      { path: "/secteurs/comptables", element: <SecteurComptablesPage /> },
    ],
  },
];

